const ExperienceList = [
    {
        title: `Experience`,
        items: [
            {
                job: `Web Design Intern`,
                company: `Hiroshi Tsunoda Design Studio (HTDS)`,
                dates: `June 2026 - July 2026`,
                bullets: 
                    [`Updated the portfolio site of the company through GitHub, staying aligned with user needs and navigation`,

                    `Designed several layouts and collaborated with team members to create a cohesive page with new information.`,

                    `Promptly kept the website updated when new information arrived, and ensured that the information was correct and accurate between three languages.`
                    ]
            },
            {
                job: `Digital Shopper`,
                company: `Walmart Digital Shopper`,
                dates: `September 2022 - Present`,
                bullets: 
                    [`Efficiently pick, prepare, and process customer orders with attention to detail to ensure timely and accurate deliveries`,

                    `Collaborated with team members to coordinate order preparation and assist drivers in providing a smooth and efficient pickup or delivery experience`,

                    `Provide friendly and proficient assistance, ensuring a positive shopping experience by addressing customer needs`
                    ]
            },
            {
                job: `Front-End Developer`,
                company: `Girls Who Code — Project Showcase`,
                dates: `January 2026 - April 2026`,
                bullets: 
                    [`Developed with team members to create a dynamic portfolio and networking site for Women in STEM known as: "DevelopHers"`,

                    `Connected the database that saves users' information to the Front-End, saving information and allowing users to adapt pages to their personal preferences`,

                    `Designed and adapted Figma Mockups to the final product to match site vision`
                    ]
            },
        ]
    }
];

export default ExperienceList;